module.exports = __webpack_public_path__ + "img/lastNameEle.f1132976.svg";